// extracted by mini-css-extract-plugin
export default {"modify_order_header":"kC","center":"lC","empty":"mC","pending":"nC","referralTitle":"oC","wrapper":"pC","title":"qC","tabs":"rC","tab":"sC","active":"tC","btn":"uC","rewards_table":"vC"};
    if(module.hot) {
      // 1726593106142
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  